module.exports = __webpack_public_path__ + "static/media/activity.5d7c8351.svg";